(function () {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  let observer;

  if (!reduceMotion && !designMode && 'IntersectionObserver' in window) {
    root.classList.add('ml-motion-ready');
    observer = new IntersectionObserver(
      (entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ml-is-visible');
          instance.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
  }

  function elementsWithin(scope, selector) {
    const elements = Array.from(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) elements.unshift(scope);
    return elements;
  }

  function sizeMobileMenu(menu) {
    const header = menu.closest('.ml-site-header');
    const panel = menu.querySelector('.ml-menu__panel');
    if (!header || !panel) return;
    const visibleHeight = Math.max(280, window.innerHeight - header.getBoundingClientRect().bottom);
    panel.style.setProperty('--ml-menu-height', `${visibleHeight}px`);
  }

  function initialize(scope) {
    elementsWithin(scope, '[data-ml-reveal]').forEach((element) => {
      if (observer) observer.observe(element);
      else element.classList.add('ml-is-visible');
    });

    elementsWithin(scope, '[data-ml-menu]:not([data-ml-bound])').forEach((menu) => {
      menu.dataset.mlBound = 'true';
      menu.addEventListener('toggle', () => {
        if (menu.open) sizeMobileMenu(menu);
        document.body.classList.toggle('ml-menu-open', menu.open);
      });
    });

    elementsWithin(scope, '[data-ml-category-menu]:not([data-ml-header-bound]), [data-ml-discover-menu]:not([data-ml-header-bound])').forEach((menu) => {
      menu.dataset.mlHeaderBound = 'true';
      menu.addEventListener('toggle', () => {
        if (menu.open) {
          elementsWithin(document, '[data-ml-category-menu], [data-ml-discover-menu]').forEach((otherMenu) => {
            if (otherMenu !== menu) otherMenu.open = false;
          });
        }
        document.body.classList.toggle('ml-category-open', Boolean(document.querySelector('[data-ml-category-menu][open]')));
      });
    });

    elementsWithin(scope, '.ml-newsletter:not([data-ml-bound])').forEach((form) => {
      form.dataset.mlBound = 'true';
      form.addEventListener('submit', () => {
        const button = form.querySelector('button[type="submit"]');
        if (!button) return;
        button.disabled = true;
        button.dataset.originalLabel = button.textContent;
        button.textContent = 'Joining...';
      });
    });

    elementsWithin(scope, '[data-ml-preview-form]:not([data-ml-preview-bound])').forEach((form) => {
      form.dataset.mlPreviewBound = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const message = form.querySelector('[data-ml-preview-message]');
        if (button) button.textContent = 'Joined';
        if (message) message.textContent = 'Preview complete. Shopify will save the subscriber after installation.';
      });
    });

    elementsWithin(scope, '[data-ml-sort-select]:not([data-ml-bound])').forEach((select) => {
      select.dataset.mlBound = 'true';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });

    elementsWithin(scope, '[data-ml-card-preview]:not([data-ml-card-preview-bound])').forEach((link) => {
      link.dataset.mlCardPreviewBound = 'true';
      const layer = link.querySelector('[data-ml-card-preview-image]');
      const frames = Array.from(link.querySelectorAll('[data-ml-card-preview-src]'))
        .map((source) => ({ src: source.dataset.mlCardPreviewSrc, promise: null }))
        .filter((frame) => frame.src);
      if (!layer || !frames.length) return;

      const hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      let active = false;
      let timer;
      let nextFrame = 0;
      let requestSerial = 0;

      function loadFrame(frame) {
        if (!frame.promise) {
          frame.promise = new Promise((resolve) => {
            const image = new Image();
            image.onload = () => resolve(true);
            image.onerror = () => resolve(false);
            image.src = frame.src;
          });
        }
        return frame.promise;
      }

      async function showNextFrame() {
        const frame = frames[nextFrame % frames.length];
        nextFrame += 1;
        const request = ++requestSerial;
        if (!await loadFrame(frame) || !active || request !== requestSerial) return;
        layer.style.backgroundImage = `url("${frame.src}")`;
        layer.classList.add('is-visible');
      }

      function stopPreview() {
        active = false;
        requestSerial += 1;
        window.clearInterval(timer);
        layer.classList.remove('is-visible');
      }

      link.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !hoverPointer.matches || active) return;
        active = true;
        nextFrame = 0;
        showNextFrame();
        frames.slice(1).forEach(loadFrame);
        if (!reduceMotion && frames.length > 1) timer = window.setInterval(showNextFrame, 1700);
      });
      link.addEventListener('pointerleave', stopPreview);
      link.addEventListener('pointercancel', stopPreview);
    });

    elementsWithin(scope, '[data-ml-product-root]:not([data-ml-product-bound])').forEach((productRoot) => {
      productRoot.dataset.mlProductBound = 'true';
      const form = productRoot.querySelector('.ml-product-form');
      const variantSelect = productRoot.querySelector('[data-ml-variant-select]');
      const variantInput = productRoot.querySelector('[data-ml-product-variant-input]');
      const submitButton = productRoot.querySelector('[data-ml-product-submit]');
      const price = productRoot.querySelector('[data-ml-product-price]');
      const comparePrice = productRoot.querySelector('[data-ml-product-compare]');
      const availability = productRoot.querySelector('[data-ml-product-availability]');
      const choices = productRoot.querySelector('.ml-product-choices');
      const sticky = productRoot.querySelector('[data-ml-product-sticky]');
      const stickySubmit = productRoot.querySelector('[data-ml-sticky-submit]');
      const gallery = productRoot.querySelector('[data-ml-gallery]');
      const mediaPanels = gallery ? Array.from(gallery.querySelectorAll('[data-ml-media-id]')) : [];
      const mediaLinks = gallery ? Array.from(gallery.querySelectorAll('[data-ml-gallery-link]')) : [];
      const galleryTrack = gallery ? gallery.querySelector('.ml-product-page__gallery-track') : null;
      const galleryMobile = window.matchMedia('(max-width: 767px)');
      let activeMediaId;

      function showMedia(id) {
        const active = mediaPanels.find(panel => panel.dataset.mlMediaId === String(id));
        if (!active) return;
        activeMediaId = String(id);
        mediaPanels.forEach(panel => {
          panel.hidden = !galleryMobile.matches && panel !== active;
          if (panel !== active) panel.querySelectorAll('video').forEach(video => video.pause());
        });
        if (galleryMobile.matches && galleryTrack) galleryTrack.scrollTo({left: active.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth'});
        mediaLinks.forEach(link => {
          if (link.dataset.mlGalleryLink === String(id)) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }
      if (gallery && mediaPanels.length) {
        gallery.dataset.mlGalleryBound = 'true';
        showMedia(gallery.dataset.initialMedia || mediaPanels[0].dataset.mlMediaId);
        mediaLinks.forEach(link => {
          link.addEventListener('click', event => {
            event.preventDefault();
            showMedia(link.dataset.mlGalleryLink);
          });
          link.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse' && !galleryMobile.matches) showMedia(link.dataset.mlGalleryLink);
          });
        });
        const resizeGallery = () => showMedia(activeMediaId);
        galleryMobile.addEventListener('change', resizeGallery);
        if (galleryTrack) galleryTrack.addEventListener('scroll', () => {
          if (!galleryMobile.matches) return;
          const active = mediaPanels.reduce((nearest, panel) => Math.abs(panel.offsetLeft - galleryTrack.scrollLeft) < Math.abs(nearest.offsetLeft - galleryTrack.scrollLeft) ? panel : nearest, mediaPanels[0]);
          activeMediaId = active.dataset.mlMediaId;
          mediaLinks.forEach(link => {
            if (link.dataset.mlGalleryLink === activeMediaId) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        }, {passive: true});
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(productRoot)) galleryMobile.removeEventListener('change', resizeGallery);
        });
      }

      function syncSticky() {
        if (!sticky || !submitButton) return;
        sticky.querySelector('[data-ml-sticky-price]').textContent = price ? price.textContent : '';
        if (variantSelect) sticky.querySelector('[data-ml-sticky-option]').textContent = variantSelect.options[variantSelect.selectedIndex].textContent.trim();
        stickySubmit.disabled = submitButton.disabled;
        stickySubmit.textContent = submitButton.textContent;
      }
      function updateVariant() {
        if (!variantSelect || !variantInput) return;
        const option = variantSelect.options[variantSelect.selectedIndex];
        if (!option) return;
        const available = option.dataset.available === 'true';
        variantInput.value = option.value;
        if (price) price.textContent = option.dataset.price || '';
        if (comparePrice) {
          comparePrice.textContent = option.dataset.compare || '';
          comparePrice.hidden = !option.dataset.compare;
        }
        if (submitButton) {
          submitButton.disabled = !available;
          submitButton.textContent = available ? submitButton.dataset.availableLabel : submitButton.dataset.soldOutLabel;
        }
        if (availability) availability.textContent = available ? availability.dataset.availableLabel : availability.dataset.unavailableLabel;
        const sku = productRoot.querySelector('[data-ml-product-sku]');
        if (sku) {
          sku.hidden = !option.dataset.sku;
          sku.querySelector('span').textContent = option.dataset.sku || '';
        }
        if (choices) choices.querySelectorAll('[data-ml-variant-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mlVariantChoice === option.value)));
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', currentUrl.toString());
        if (option.dataset.mediaId) showMedia(option.dataset.mediaId);
        syncSticky();
      }
      if (variantSelect && variantInput) {
        variantSelect.addEventListener('change', updateVariant);
        if (choices) {
          choices.hidden = false;
          productRoot.querySelector('.ml-product-variant-select').hidden = true;
          choices.querySelectorAll('[data-ml-variant-choice]').forEach(button => button.addEventListener('click', () => {
            variantSelect.value = button.dataset.mlVariantChoice;
            updateVariant();
          }));
        }
      }
      syncSticky();

      if (sticky && submitButton && form && 'IntersectionObserver' in window) {
        let buttonVisible = false;
        let footerVisible = false;
        const mobile = window.matchMedia('(max-width: 767px)');
        const showSticky = () => { sticky.hidden = !mobile.matches || buttonVisible || footerVisible; };
        const buttonObserver = new IntersectionObserver(entries => {
          buttonVisible = entries[0].isIntersecting;
          showSticky();
        });
        buttonObserver.observe(submitButton);
        const footer = document.querySelector('.ml-footer');
        const footerObserver = footer ? new IntersectionObserver(entries => {
          footerVisible = entries[0].isIntersecting;
          showSticky();
        }) : null;
        if (footerObserver) footerObserver.observe(footer);
        mobile.addEventListener('change', showSticky);
        stickySubmit.addEventListener('click', () => {
          if (!submitButton.disabled) form.requestSubmit(submitButton);
        });
        form.addEventListener('submit', () => {
          stickySubmit.disabled = true;
          stickySubmit.textContent = submitButton.dataset.loadingLabel || submitButton.textContent;
        });
        document.addEventListener('shopify:section:unload', event => {
          if (!event.target.contains(productRoot)) return;
          buttonObserver.disconnect();
          if (footerObserver) footerObserver.disconnect();
          mobile.removeEventListener('change', showSticky);
        });
      }
    });

    elementsWithin(scope, 'form[action*="/cart/add"]:not([data-ml-cart-bound])').forEach((form) => {
      form.dataset.mlCartBound = 'true';
      form.addEventListener('submit', () => {
        const button = form.querySelector('button[type="submit"][name="add"]');
        if (!button || button.disabled) return;
        button.disabled = true;
        button.dataset.originalLabel = button.textContent;
        button.textContent = button.dataset.loadingLabel || 'Adding...';
      });
    });

  }

  initialize(document);

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const button = form.querySelector('button[type="submit"][name="add"]');
      if (!button || !button.dataset.originalLabel) return;
      const select = form.querySelector('[data-ml-variant-select]');
      const available = select ? select.options[select.selectedIndex].dataset.available === 'true' : true;
      button.disabled = !available;
      button.textContent = available ? (button.dataset.availableLabel || button.dataset.originalLabel) : button.dataset.soldOutLabel;
      const stickyButton = form.closest('[data-ml-product-root]')?.querySelector('[data-ml-sticky-submit]');
      if (stickyButton) { stickyButton.disabled = button.disabled; stickyButton.textContent = button.textContent; }
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-ml-category-menu], [data-ml-discover-menu]')) return;
    elementsWithin(document, '[data-ml-category-menu], [data-ml-discover-menu]').forEach((menu) => {
      menu.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const activeDisclosure = document.activeElement.closest('[data-ml-category-menu], [data-ml-discover-menu], [data-ml-menu]');
    const trigger = activeDisclosure ? activeDisclosure.querySelector('summary') : null;
    event.preventDefault();
    elementsWithin(document, '[data-ml-category-menu], [data-ml-discover-menu], [data-ml-menu]').forEach((menu) => {
      menu.open = false;
    });
    if (trigger) window.setTimeout(() => trigger.focus(), 0);
  });

  window.addEventListener('resize', () => {
    elementsWithin(document, '[data-ml-menu][open]').forEach(sizeMobileMenu);
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', () => {
    document.body.classList.remove('ml-menu-open');
    document.body.classList.remove('ml-category-open');
  });
})();

